import React from 'react'

const UserCreatePage = () => {
  return (
    <div>UserCreatePage</div>
  )
}

export default UserCreatePage